var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { createContext, useReducer, } from "react";
import { initialPDFState, reducer, } from "./reducer";
var PDFContext = createContext({ state: initialPDFState, dispatch: function () { return null; } });
var PDFProvider = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var children = _a.children, mainState = _a.mainState;
    var _m = useReducer(reducer, __assign(__assign({}, initialPDFState), { defaultZoomLevel: (_d = (_c = (_b = mainState.config) === null || _b === void 0 ? void 0 : _b.pdfZoom) === null || _c === void 0 ? void 0 : _c.defaultZoom) !== null && _d !== void 0 ? _d : initialPDFState.defaultZoomLevel, zoomLevel: (_g = (_f = (_e = mainState.config) === null || _e === void 0 ? void 0 : _e.pdfZoom) === null || _f === void 0 ? void 0 : _f.defaultZoom) !== null && _g !== void 0 ? _g : initialPDFState.zoomLevel, zoomJump: (_k = (_j = (_h = mainState.config) === null || _h === void 0 ? void 0 : _h.pdfZoom) === null || _j === void 0 ? void 0 : _j.zoomJump) !== null && _k !== void 0 ? _k : initialPDFState.zoomJump, paginated: ((_l = mainState.config) === null || _l === void 0 ? void 0 : _l.pdfVerticalScrollByDefault)
            ? false
            : initialPDFState.paginated, mainState: mainState })), state = _m[0], dispatch = _m[1];
    return (React.createElement(PDFContext.Provider, { value: { state: state, dispatch: dispatch } }, children));
};
export { PDFContext, PDFProvider };
